module.exports = __webpack_public_path__ + "static/media/youtube.936666f1.svg";